import classnames from 'classnames';

import HorizontalContainerWrapper from 'pages/NewHome/HorizontalContainerWrapper';

import useStyles from './styles';

const HomeTopSectionFallback = () => {
  const styles = useStyles({ titleColor: '' });
  return (
    <HorizontalContainerWrapper>
      <div className={styles.root}>
        <i className={styles.content}>
          <i className={classnames('skeleton', styles.choices, styles.choicesSK)} />
          <i className={classnames('skeleton', styles.titleCon)} />
          <i className={classnames('skeleton', styles.descriptionCon, styles.descriptionSK)} />
          <i className={classnames('skeleton', styles.buttonSK)} />
        </i>
        <i className={classnames('skeleton', styles.mediaSK, styles.media)} />
      </div>
    </HorizontalContainerWrapper>
  );
};

export default HomeTopSectionFallback;
